export interface INavigationRoute {
  name: string
  href?: string
  icon: string
  childrenRoutes?: {
    name: string
    href: string
    icon: string
  }[]
}

export default {
  root: {
    href: 'app-rb-empresas',
    name: 'RB Empresas',
  } as Omit<INavigationRoute, 'icon' | 'childrenRoutes'>,
  routes: [
    {
      name: 'Início',
      href: 'inicio',
      icon: 'mso-home',
    },
    {
      name: 'Painel de Vendas',
      href: 'vendas',
      icon: 'mso-receipt_long',
    },
    {
      name: 'Produtos e Serviços',
      href: 'produtos-e-servicos',
      icon: 'mso-shelves',
    },
    {
      name: 'Faturamento',
      icon: 'mso-monitoring',
      childrenRoutes: [
        {
          name: 'Meu Dinheiro',
          href: 'meu-dinheiro',
          icon: 'mso-money_bag',
        },
        {
          name: 'Extrato',
          href: 'extrato',
          icon: 'mso-receipt',
        },
        {
          name: 'Transferências',
          href: 'transferencias',
          icon: 'mso-swap_horiz',
        },
      ],
    },
    {
      name: 'Configurações',
      icon: 'mso-settings',
      href: 'configuracoes',
    },
  ] as INavigationRoute[],
}
